import { Typography, Box } from "@mui/material";

const Header = ({ title, subtitle }) => (
  <Box>
    <Typography
      sx={{
        fontSize: 22,
        fontWeight: 700,
        color: "#0F172A",
        letterSpacing: "-0.5px",
        fontFamily: "IBM Plex Sans, sans-serif",
        mb: 0.25,
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontSize: 14,
        color: "#64748B",
        fontFamily: "IBM Plex Sans, sans-serif",
      }}
    >
      {subtitle}
    </Typography>
  </Box>
);

export default Header;
